import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { GET_PUBLICATION_SCHEDULE_QUERY } from "../queries/publicationScheduleQueries";
import { getAuthToken } from "../utils/authUtils";

// schedule-view-agent-api  (API ID: eyam4lawwrbm3byj4rtnanonmy)
const GRAPHQL_ENDPOINT =
  "https://ba26jlfifzet3jg4t7sndumok4.appsync-api.us-east-1.amazonaws.com/graphql";

const httpLink = createHttpLink({ uri: GRAPHQL_ENDPOINT });

const authLink = setContext((_, { headers }) => {
  const token = getAuthToken();
  if (!token) {
    console.error("publicationScheduleApi - No valid JWT token found!");
  }
  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: token } : {}),
    },
  };
});

// NOTE: Do NOT call clearAuthState() here. A 401 from this specific endpoint
// means Cognito auth has not yet been enabled on the schedule-view-agent-api —
// it does not mean the user's session is invalid. Logging out here would end
// the user's session across the entire app based on an unrelated API's config.
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message }) => {
      console.error("publicationScheduleApi - GraphQL error:", message);
    });
  }
  if (networkError) {
    console.error("publicationScheduleApi - Network error:", networkError?.statusCode, networkError?.message);
  }
});

const client = new ApolloClient({
  link: errorLink.concat(authLink).concat(httpLink),
  cache: new InMemoryCache(),
});

export const fetchPublicationScheduleFromApi = async ({ ticketId, tenantId }) => {
  console.log(
    `publicationScheduleApi - fetchPublicationScheduleFromApi - ticketId: ${ticketId}, tenantId: ${tenantId}`
  );
  const response = await client.query({
    query: GET_PUBLICATION_SCHEDULE_QUERY,
    variables: { ticketId, tenantId },
    fetchPolicy: "network-only",
  });
  return response?.data?.getPublicationSchedule;
};
